import qs from 'qs';
import MCLib from '../static/js/mc-lib';

const DOMAIN_MAP = {
  S1: 'https://mc.exacttarget.com',
  S5: 'https://mc.boa.exacttarget.com'
};

const LOGOUT_PATH = '/stargate/sso/mc/logout';

const parsedQueryString = qs.parse(window.location.search.substr(1));
const stackKey = parsedQueryString.stackKey;
let stackUrl = DOMAIN_MAP[stackKey];
if (!stackUrl && stackKey) {
  const regex = /^s\d{1,3}$/i;
  if (regex.test(stackKey)) {
    stackUrl = `https://mc.${stackKey.toLowerCase()}.exacttarget.com`;
  } else {
    const qaregex = /^QA(\d)S(\d)$/i;
    const match = stackKey.match(qaregex);
    if (match) {
      const s = match[2];
      const qa = match[1];
      stackUrl = `https://mc.s${s}.qa${qa}.exacttarget.com`;
    }
  }
}

const mcLib = new MCLib({ allowedOrigin: stackUrl, mc: window.top });

mcLib.registerLogoutUrl(window.location.origin + LOGOUT_PATH);

export default mcLib;
